import { toast } from "react-toastify";
import * as actionTypes from "./actionTypes";
import authService from "../../api/authService";
import {
  RECOVER_FASE_CONFIRMATION,
  RECOVER_FASE_COMPLETED,
  RECOVER_FASE_VALIDATION,
} from "../../infrastructure/appConstants";
import { resetScroll } from "../../util/JsUtils";

export const setRecoverCustomer = (currentCustomer, fase) => {
  return { type: actionTypes.RECOVER_USER, payload: { currentCustomer, fase } };
};

export const recoverValidation = (data) => async (dispatch) => {
  try {
    const response = await authService.recoverValidation(data);
    //Actualizando fase  a confirmacion
    dispatch(setRecoverCustomer(response.data, RECOVER_FASE_CONFIRMATION));
    toast.success(response.message);
  } catch (error) {
    throw error;
  }
};

export const recoverConfirmation = (data, currentCustomer) => async (
  dispatch
) => {
  try {
    const response = await authService.recoverConfirmation(data);
    //Actualizando fase  a confirmacion
    dispatch(setRecoverCustomer(currentCustomer, RECOVER_FASE_COMPLETED));
    resetScroll();
    toast.success(response.message);
  } catch (error) {
    throw error;
  }
};

export const cleanRecover = () => (dispatch) => {
  try {
    //Clean data recover
    dispatch(setRecoverCustomer(null, RECOVER_FASE_VALIDATION));
  } catch (error) {
    throw error;
  }
};

export const sendVerification = async (data) => {
  try {
    return await authService.sendVerification(data);
  } catch (error) {
    throw error;
  }
};
